module.exports = __webpack_public_path__ + "img/icon-illustration-coupon-order.b8a1cfb2.svg";